import { makeStyles } from '@material-ui/core';

export const NavBarStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.colors.Background_Primary,
    color: theme.colors.Text_1,
    minHeight: theme.spacing(9),
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      borderBottom: `1px solid ${theme.colors.Background_1}`,
      minHeight: theme.spacing(8),
    },
  },

  toolbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 0 0',
    width: '100%',
    maxWidth: '1024px',
    padding: theme.spacing(1, 0),
  },

  brandImage: {
    width: '100%',
    maxWidth: theme.spacing(18),
    maxHeight: theme.spacing(7.5),
  },

  byAstro: {
    width: '100%',
    padding: theme.spacing(0, 0.9),
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    fontSize: '.6em',
    fontWeight: 700,
    minWidth: 'max-content',

    '& img': {
      width: '100%',
      marginLeft: theme.spacing(0.2),
      maxWidth: theme.spacing(6),
      maxHeight: theme.spacing(6),
    },
  },
}));
